import React from 'react'
import _Input from './Input/Input'

export const Input = props => (
  <_Input {...props} type='text' />
)

export const Output = props => {
  let value = props.data || props.value
  if (props.picklist && props.type === 'PICKLIST' && Array.isArray(props.picklist)) {
    const picklistObj = props.picklist && props.picklist.find(pick => pick.value === value)
    value = picklistObj ? picklistObj.label : value
  }
  let val = props.isHtmlFormatted
    ? (<p dangerouslySetInnerHTML={{ __html: value }} />)
    // Note HTML data also can contain new line mark.
    : value && typeof value.split === 'function' ? value.split('\n').map((line, key) => <span key={key}>{line}<br /></span>) : value
  return <span>{val || ''}</span>
}
